import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import I18n from 'i18n-js';
import { Button, Modal, Tooltip } from 'grab-ui';
import InfoCircle from 'public/icons/info-circle.svg';
import { safeHTML } from 'common/utils/safe-html';
import styles from './styles.less';

const TaxiTypeTNC = ({ serviceType, className }) => {
  const taxiTypeName = get(serviceType, 'name');
  const taxiTypeInfo = get(serviceType, 'taxiTypeInfo');

  const [modalVisible, setModalVisible] = useState(false);

  const onOpen = useCallback(
    () => {
      setModalVisible(true);
    },
    [modalVisible, setModalVisible],
  );

  const onClose = useCallback(
    () => {
      setModalVisible(false);
    },
    [modalVisible, setModalVisible],
  );

  const sanitizedTaxiTypeInfo = useMemo(
    () => {
      return safeHTML(taxiTypeInfo, {
        ALLOWED_TAGS: [
          'a',
          'b',
          'br',
          'div',
          'em',
          'i',
          'li',
          'ol',
          'p',
          'span',
          'strong',
          'u',
          'ul',
        ],
        ALLOWED_ATTR: ['href', 'style', 'alt', 'target', 'colspan', 'rel'],
      });
    },
    [taxiTypeInfo],
  );

  return (
    <span className={cx(styles.tncInfoIcon, className)}>
      <a onClick={onOpen} onKeyDown={onOpen} role={'button'} tabIndex={0}>
        <Tooltip
          title={I18n.t('v2.taxiTypeTNC.hoverText')}
          overlayClassName={styles.tncOverlay}
        >
          <img src={InfoCircle} alt={'Taxi-Type-TNC'} />
        </Tooltip>
      </a>
      <Modal
        visible={modalVisible}
        centered
        footer={null}
        closable={false}
        maskClosable
        onCancel={onClose}
      >
        <div className={styles.tncContainer}>
          {taxiTypeName && (
            <h1 className={styles.tncTitle}> {taxiTypeName} </h1>
          )}
          <div
            className={styles.tncContent}
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{ __html: sanitizedTaxiTypeInfo }}
          />
          <div className={styles.tncActions}>
            <Button
              type={'primary'}
              className={cx(styles.tncClose)}
              onClick={onClose}
            >
              {I18n.t('v2.taxiTypeTNC.close')}
            </Button>
          </div>
        </div>
      </Modal>
    </span>
  );
};

TaxiTypeTNC.propTypes = {
  className: PropTypes.string,
  serviceType: PropTypes.shape({}).isRequired,
};

TaxiTypeTNC.defaultProps = {
  className: '',
};

export default TaxiTypeTNC;
